import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginResponseModel } from 'src/app/shared/models/loginResponseModel';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BackendApiService } from 'src/app/shared/services/backend-api.service';

@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.scss'],
})
export class DemoComponent {
  showWarning: boolean = false;
  errors: Array<string> = [];

  constructor(
    private backendService: BackendApiService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const id: string = this.route.snapshot.queryParams['id'] ?? '';
    this.validateUserId(id);
  }

  validateUserId(userId: string) {
    this.backendService.validateUserId(userId).subscribe({
      next: (user: LoginResponseModel) => {
        let result = this.authService.setUser(user);
        if ('roles' in result) {
          this.router.navigate(['user']);
        } else {
          var message = (result as any[])[0];

          if (message) {
            this.showWarning = true;
            this.errors = message;
          }
        }
      },
      error: (error: HttpErrorResponse) => {
        this.showWarning = true;
        this.errors = [error.message];
      },
    });
  }
}
